module.exports = __webpack_public_path__ + "a8252c1870b05b7e8dd6ad4f9d3915df.png";